import { Directive, Output, HostBinding, HostListener, EventEmitter, Input } from '@angular/core';

@Directive({
  selector: '[appFileDragDropDirective]'
})
export class FileDragDropDirective {
  @Output() dropReceived = new EventEmitter<any>();
  @Input() types: string[] = [];
  @Input() extensions: string[] = [];

  @HostBinding('style.background') public background = "#eee";
  @HostListener('dragover', ['$event']) onDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    this.background = "#999";
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    this.background = "#eee";
  }

  @HostListener('drop', ['$event']) public onDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    this.background = "#eee";

    let files = e.dataTransfer.files;
    if (files.length > 0) {
      //Add some validation to the type of file.  Examine the mime type.
      let f = files[0];
      let xtn = f.name.substring(f.name.lastIndexOf('.') + 1, f.name.length) || f.name;
      console.log("File extension: " + xtn);
      console.log("File mime type: " + f.type);

      if (!f.type) {
        if (this.extensions.indexOf(xtn) > -1) {
          console.log("Found " + xtn + " in extension list");
          this.dropReceived.emit(f);
        } else {
          console.log("did not find " + xtn + " in extension list");
          alert("Only XLS or XLSX files can be imported.  Please retry with a different file format");
        }  
      } else {
        if (this.types.indexOf(f.type) > -1) {
          console.log("Found " + f.type + "in mime type list");
          this.dropReceived.emit(f);
        } else {
          //Fall back on extension check?
          if (this.extensions.indexOf(xtn) > -1) {
            console.log("Failed mime check but passed extension check");
            this.dropReceived.emit(f);
          } else {
            alert("The file you have uploaded is not recognised as an excel spreadsheet file.  Please recheck your file and try again.");
          }
        }
      }
      //this.dropReceived.emit(files[0]);
    }
  }

  constructor() { }

}
